import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toggle-switch/dist/css/switch.min.css';
import 'react-dropdown-tree-select/dist/styles.css';

import React, { Component } from 'react';
import TopNav from './components/TopNav';
import 'moment-timezone';
import moment from 'moment';
import { ApolloProvider } from 'react-apollo';
import { GQL_ENDPOINT } from './constants';
import { ToastContainer } from 'react-toastify';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import ConfirmationDialog from './ConfirmationDialog';
import { resolvers, typeDefs } from './resolvers';
import { amplitudeInit } from './utilities';
import { ApolloLink, from } from 'apollo-boost';
import { getLoggedInUser } from './permissions';

moment.tz.setDefault('Asia/Kolkata');

const httpLink = createUploadLink({
  uri: GQL_ENDPOINT
});

const responseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const token = localStorage.getItem('token');
    const isLoginRequired =
      !!token &&
      response.errors &&
      response.errors[0] &&
      (response.errors[0].message === 'Illegal user' ||
        (response.errors[0].extensions &&
          response.errors[0].extensions.code === 'UNAUTHENTICATED'));

    if (isLoginRequired) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
      return;
    }

    return response;
  });
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  const user = getLoggedInUser();
  const userRole = user && user.role;
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      'x-role': userRole || ''
    }
  };
});

const cache = new InMemoryCache();

const client = new ApolloClient({
  link: from([responseLink, authLink, httpLink]),
  cache,
  resolvers,
  typeDefs
});

cache.writeData({
  data: {
    userHospitals: [],
    selectedHospitals: []
  }
});

class App extends Component {
  componentDidMount = () => {
    amplitudeInit();
  };
  render() {
    return (
      <ApolloProvider client={client}>
        <ToastContainer
          position="top-center"
          autoClose={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
        <ConfirmationDialog />
        <TopNav />
      </ApolloProvider>
    );
  }
}

export default App;
